import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  loading?: boolean;
  openDialog?: boolean;
  onSubmit?: (value: string) => void;
  // Customizable Area Start
  minBarcodeLength?: number;
  // Customizable Area End
}

interface S {
  txtInputValue: string;
  txtSavedValue: string;
  enableField: boolean;
  // Customizable Area Start
  open: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class BarcodesScannerController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  barCode= "";
  scanning= false;
  timer: NodeJS.Timeout | undefined = undefined;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      // Customizable Area End
    ];

    this.state = {
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false,
      // Customizable Area Start
      open: false
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);

    if (message.id === getName(MessageEnum.AccoutLoginSuccess)) {
      let value = message.getData(getName(MessageEnum.AuthTokenDataMessage));

      this.showAlert(
        "Change Value",
        "From: " + this.state.txtSavedValue + " To: " + value
      );

      this.setState({ txtSavedValue: value });
    }

    // Customizable Area Start
    // Customizable Area End
  }

  txtInputWebProps = {
    onChangeText: (text: string) => {
      this.setState({ txtInputValue: text });
    },
    secureTextEntry: false,
  };

  txtInputMobileProps = {
    ...this.txtInputWebProps,
    autoCompleteType: "email",
    keyboardType: "email-address",
  };

  txtInputProps = this.isPlatformWeb()
    ? this.txtInputWebProps
    : this.txtInputMobileProps;

  btnShowHideProps = {
    onPress: () => {
      this.setState({ enableField: !this.state.enableField });
      this.txtInputProps.secureTextEntry = !this.state.enableField;
      this.btnShowHideImageProps.source = this.txtInputProps.secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  btnShowHideImageProps = {
    source: this.txtInputProps.secureTextEntry
      ? imgPasswordVisible
      : imgPasswordInVisible,
  };

  btnExampleProps = {
    onPress: () => this.doButtonPressed(),
  };

  doButtonPressed() {
    let msg = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(
      getName(MessageEnum.AuthTokenDataMessage),
      this.state.txtInputValue
    );
    this.send(msg);
  }

  // web events
  setInputValue = (text: string) => {
    this.setState({ txtInputValue: text });
  };

  setEnableField = () => {
    this.setState({ enableField: !this.state.enableField });
  };

  // Customizable Area Start
  async componentDidMount(): Promise<void> {
    super.componentDidMount()
    document.addEventListener("keypress", this.handleScan)
  }
  async componentWillUnmount(): Promise<void> {
    super.componentWillUnmount()
    document.removeEventListener("keypress", this.handleScan)
  }
  handleScan =  (event: KeyboardEvent) => {
    const textInput = event.key;
    if (/^[a-zA-Z0-9#]$/.test(textInput)) {
      this.barCode += textInput;
    }

    if(!this.scanning) {
      this.scanning = true;
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        const minLength = this.props.minBarcodeLength ?? 11;
        if (this.barCode.length > minLength) {
          this.setState({ txtInputValue: this.barCode }, () =>
            this.handleSubmit()
          );
        }
        this.barCode = "";
        this.scanning = false;
      }, 800);
    }
  };

  hanldeClose = () => {
    this.barCode = "";
    this.scanning = false;
    this.setState({open: false, txtInputValue: "", txtSavedValue: ""})
  }

  toggleDialog = () => this.setState({open: !this.state.open})

  handleSubmit = () => {
    if (this.state.txtInputValue) {
      this.props.onSubmit?.(this.state.txtInputValue)
    }
  }

  handlePress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !this.scanning) {
      this.props.onSubmit?.(this.state.txtInputValue)
    }
  }
  // Customizable Area End
}
